module.exports = __webpack_public_path__ + "assets/img/ocean_warrior-96b8abb1.jpg";